import React from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Zoom,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { mastersApi } from "../../../../services/MasterDataServices";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: "150ms" }} ref={ref} {...props} />;
});

const emptyRow = {
  code: "",
  name: "",
  description: "",
  museum_type_id: "",
  question: "",
  is_active: false,
};

export default function QuestionsDialog({ open, row, onClose, onSubmit }) {
  const [museumTypes, setMuseumTypes] = React.useState([]);
  const [form, setForm] = React.useState(emptyRow);

  React.useEffect(() => {
    mastersApi("museum_types", "get")
      .then((res) => setMuseumTypes(res?.data || []))
      .catch(() => setMuseumTypes([]));
  }, []);

  // Update form when row is provided (edit mode)
  React.useEffect(() => {
    if (row) {
      setForm({
        ...emptyRow,
        ...row,
        museum_type_id: row?.museum_type?.id || row?.museum_type_id || "",
      });
    } else {
      setForm(emptyRow);
    }
  }, [row]);

  const handleChange = (key, value) => {
    setForm((p) => ({ ...p, [key]: value }));
  };

  const handleSave = () => {
    onSubmit?.({ ...form, id: row?.id });
  };

  return (
    <Dialog open={open} TransitionComponent={Transition} keepMounted fullWidth maxWidth={"sm"}>
      <DialogTitle color={"#616B88"} sx={{ fontSize: 24 }} className={"text-bold"} fontWeight={700}>
        {row ? "Edit Question" : "Add Question"}
      </DialogTitle>
      <Box className={"common-divider"} />
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={museumTypes}
              size={"small"}
              value={museumTypes.find((m) => m?.id === form.museum_type_id) || null}
              getOptionLabel={(o) => o?.name || o?.code || ""}
              onChange={(_, next) => handleChange("museum_type_id", next?.id || "")}
              renderInput={(params) => <TextField {...params} label="Museum Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size={"small"} label="Code" value={form.code} onChange={(e) => handleChange("code", e.target.value)} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size={"small"} label="Name" value={form.name} onChange={(e) => handleChange("name", e.target.value)} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size={"small"}
              label="Description"
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size={"small"}
              multiline
              minRows={3}
              label="Question"
              value={form.question}
              onChange={(e) => handleChange("question", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <RadioGroup
                row
                value={form.is_active ? "active" : "inactive"}
                onChange={(e) => handleChange("is_active", e.target.value === "active")}
              >
                <FormControlLabel value="active" control={<Radio />} label="Active" />
                <FormControlLabel value="inactive" control={<Radio />} label="Inactive" />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={"outlined"} color={"error"} className={"text-capitalize"}>
          cancel
        </Button>
        <Button onClick={handleSave} variant={"contained"} className={"text-capitalize"}>
          {row ? "Update" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
